import { ruleRunner } from 'validations/ruleRunner';
import { required, arrayMinLength, minimun, maximum, ruleIfValue, ruleIfInArray } from 'validations/rules';

const CAIXA_PACOTE = '1',
  ROLO_PRISMA = '2';

const Validations = [
  ruleRunner('zip_code', 'CEP de origem', required),
  ruleRunner(
    'weight',
    'peso',
    required,
    ruleIfInArray('deliveryType', [40010], maximum(30)),
    ruleIfInArray('deliveryType', [40215], maximum(10)),
    ruleIfInArray('deliveryType', [41106], maximum(30))
  ),
  ruleRunner(
    'height',
    'altura',
    ruleIfValue('format', CAIXA_PACOTE, required),
    ruleIfValue('format', CAIXA_PACOTE, minimun(2)),
    ruleIfValue('format', CAIXA_PACOTE, maximum(105))
  ),
  ruleRunner(
    'width',
    'largura',
    ruleIfValue('format', CAIXA_PACOTE, required),
    ruleIfValue('format', CAIXA_PACOTE, minimun(11)),
    ruleIfValue('format', CAIXA_PACOTE, maximum(105))
  ),
  ruleRunner(
    'length',
    'comprimento',
    required,
    ruleIfValue('format', CAIXA_PACOTE, minimun(16)),
    ruleIfValue('format', ROLO_PRISMA, minimun(18)),
    maximum(105)
  ),
  ruleRunner(
    'diameter',
    'diâmetro',
    ruleIfValue('format', ROLO_PRISMA, required),
    ruleIfValue('format', ROLO_PRISMA, minimun(5)),
    ruleIfValue('format', ROLO_PRISMA, maximum(91))
  ),
  ruleRunner('delivery_options', 'tipo de entrega', arrayMinLength(1)),
];

export default Validations;
